import { openDB, deleteDB } from 'idb/with-async-ittr.js';

const dbPromise = () => openDB('PedidosDB', 9, {
  upgrade(db, oldVersion) {
    /* eslint-disable no-fallthrough */
    switch(oldVersion) {
      case 0:
        // Create a store of objects
        var pedidosOS = db.createObjectStore('saidas', {
          // The 'id' property of the object will be the key.
          keyPath: 'id_interno',
          autoIncrement: true
        });
        // Create an index on the 'id_saida' property of the objects.
        pedidosOS.createIndex('id_saida', 'id_saida');
      case 1:
        var clientOS = db.createObjectStore('clientes', {
          keyPath: 'id_interno',
          autoIncrement: true
        });
        // Create an index on the 'id_cliente' property of the objects.
        clientOS.createIndex('id_cliente', 'id_cliente');
      case 2:
        db.createObjectStore('produtos', {
          keyPath: 'id_produto'
        });
      case 3:
        db.createObjectStore('condicoesPagamento', {
          keyPath: 'id_condicao_pagamento'
        });
      case 4:
        db.createObjectStore('tiposDocumento', {
          keyPath: 'id_tipo_documento'
        });
      case 5:
        db.createObjectStore('unidades', {
          keyPath: 'id_unidade'
        });
      case 6:
        db.createObjectStore('tabelasPreco', {
          keyPath: 'id_tabela_preco'
        });
      case 7:
        db.createObjectStore('empresas', {
          keyPath: 'id_empresa'
        });
      case 8:
        db.createObjectStore('catalogos', {
          keyPath: 'id_catalogo'
        });
    }
  },
});

async function addToStore(storeName, obj) {
  const db = await dbPromise(storeName);
  return db.add(storeName, obj);
}

async function updateItem(storeName, obj) {
  const db = await dbPromise(storeName);
  await db.put(storeName, obj);
}

async function addMultipleToStore(storeName, array) {
  const db = await dbPromise(storeName);

  for (const item of array) {
    await db.add(storeName, item);
  }
}

async function getAll(storeName) {
  const db = await dbPromise(storeName);
  return db.getAll(storeName);
}

async function getAllFromIndex(storeName, indexName) {
  const db = await dbPromise(storeName);
  return db.getAllFromIndex(storeName, indexName)
}

async function getFromIndex(storeName, indexName, id) {
  const db = await dbPromise(storeName);
  return db.getFromIndex(storeName, indexName, Number(id))
}

async function getById(storeName, id) {
  const db = await dbPromise(storeName);
  return db.get(storeName, Number(id));
}

async function deleteFromStore(storeName, key) {
  const db = await dbPromise(storeName);
  return db.delete(storeName, key);
}

async function clearStore(storeName) {
  const db = await dbPromise(storeName);
  return db.clear(storeName);
}

function destroyDb() {
  return deleteDB('PedidosDB');
}

export default {
  addToStore,
  updateItem,
  addMultipleToStore,
  getAll,
  getAllFromIndex,
  getFromIndex,
  getById,
  deleteFromStore,
  clearStore,
  destroyDb
}